import React from 'react'

import { UnknownObject } from 'src/utils/reactTypes'

export const CheckIcon: React.FC<UnknownObject> = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.1668 10.1567V11C20.1657 12.9768 19.5256 14.9002 18.3421 16.4834C17.1585 18.0666 15.4948 19.2248 13.5992 19.7853C11.7036 20.3458 9.67765 20.2784 7.82343 19.5934C5.9692 18.9084 4.3861 17.6423 3.31021 15.984C2.23432 14.3257 1.7233 12.3641 1.85337 10.3917C1.98343 8.41922 2.7476 6.54167 4.03192 5.03902C5.31624 3.53637 7.05188 2.48914 8.98 2.05351C10.9081 1.61787 12.9254 1.81718 14.731 2.62171"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.1667 3.66663L11 12.8425L8.25 10.0925"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
